/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreStandardTaskResponseDto } from '../../models/core-standard-task-response-dto';

export interface StandardTasksControllerRemove$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the standard task to delete.
 */
  id: string;
}

export function standardTasksControllerRemove(http: HttpClient, rootUrl: string, params: StandardTasksControllerRemove$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, standardTasksControllerRemove.PATH, 'delete');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreStandardTaskResponseDto>;
    })
  );
}

standardTasksControllerRemove.PATH = '/o2-core/standard-tasks/{tenant}/{id}';
